import { render, staticRenderFns } from "./StatisticsTotalCount.vue?vue&type=template&id=73f22049"
var script = {}
import style0 from "./StatisticsTotalCount.vue?vue&type=style&index=0&id=73f22049&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports